// src/Components/layout/Sidebar.jsx
import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import logoWhite from "../../assets/images/logo-white.svg";

// Close icon for mobile
const IconClose = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

// Simple line icons to match the design
const IconDashboard = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="9" rx="2" />
    <rect x="14" y="3" width="7" height="5" rx="2" />
    <rect x="14" y="11" width="7" height="10" rx="2" />
    <rect x="3" y="15" width="7" height="6" rx="2" />
  </svg>
);

const IconJobs = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="7" width="18" height="13" rx="2" />
    <path d="M9 7V5a3 3 0 0 1 6 0v2" />
  </svg>
);

const IconDrivers = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c0-4 4-6 8-6s8 2 8 6" />
    <path d="M15 8c1.5 0 3 1 3 3" />
  </svg>
);

const IconUsers = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
    <circle cx="11" cy="7" r="4" />
    <path d="M20 8a3 3 0 1 0-2.24 5" />
  </svg>
);

const IconReviews = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 17.75 6.16 21l1.12-6.53L2 9.75l6.58-.96L12 3l3.42 5.79L22 9.75l-5.28 4.72L17.84 21z" />
  </svg>
);

const IconInbox = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 12h-6l-2 3h-4l-2-3H2" />
    <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
  </svg>
);

const IconRouteOpt = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="6" cy="6" r="2" />
    <circle cx="18" cy="18" r="2" />
    <path d="M6 8c0 7 12 3 12 8" />
  </svg>
);

const IconSettings = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 8 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 3.6 15a1.65 1.65 0 0 0-1.51-1H2a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 3.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 8 3.6 1.65 1.65 0 0 0 9 2.09V2a2 2 0 0 1 4 0v.09A1.65 1.65 0 0 0 16 3.6a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 20.4 9c.36.53.56 1.16.6 1.8V11a1.65 1.65 0 0 0-1 1.51z" />
  </svg>
);

const IconHelp = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-2 2.5-2 4" />
    <line x1="12" y1="17" x2="12" y2="17" />
  </svg>
);

export default function Sidebar({ isOpen, onClose, isMobile }) {
  const handleNavClick = () => {
    if (isMobile && onClose) {
      onClose();
    }
  };

  return (
    <aside className="mq-sidebar">
      {/* Mobile close button */}
      {isMobile && (
        <button className="mq-sidebar-close-btn" onClick={onClose} aria-label="Close menu">
          <IconClose />
        </button>
      )}

      {/* Yellow header with circular logo */}
      <div className="mq-sidebar-header">
        <div className="mq-sidebar-logo-wrap">
          <img src={logo} alt="Marquee Couriers" className="mq-sidebar-logo mq-logo-lighttheme" />
          <img src={logoWhite} alt="Marquee Couriers" className="mq-sidebar-logo mq-logo-darktheme" />
        </div>
      </div>

      <div className="mq-sidebar-inner">
        {/* MAIN section */}
        <div className="mq-nav-section">
          <div className="mq-nav-label">MAIN</div>
          <nav className="mq-nav">
            <NavLink
              to="/dashboard"
              onClick={handleNavClick}
              className={({ isActive }) =>
                "mq-nav-link" + (isActive ? " mq-nav-link-active" : "")
              }
            >
              <span className="mq-nav-icon">
                <IconDashboard />
              </span>
              <span>Dashboard</span>
            </NavLink>

            <NavLink
              to="/jobs"
              onClick={handleNavClick}
              className={({ isActive }) =>
                "mq-nav-link" + (isActive ? " mq-nav-link-active" : "")
              }
            >
              <span className="mq-nav-icon">
                <IconJobs />
              </span>
              <span>Jobs</span>
            </NavLink>

            <NavLink
              to="/drivers"
              onClick={handleNavClick}
              className={({ isActive }) =>
                "mq-nav-link" + (isActive ? " mq-nav-link-active" : "")
              }
            >
              <span className="mq-nav-icon">
                <IconDrivers />
              </span>
              <span>Drivers</span>
            </NavLink>

            <NavLink
              to="/users"
              onClick={handleNavClick}
              className={({ isActive }) =>
                "mq-nav-link" + (isActive ? " mq-nav-link-active" : "")
              }
            >
              <span className="mq-nav-icon">
                <IconUsers />
              </span>
              <span>Users</span>
            </NavLink>

            <NavLink
              to="/reviews"
              onClick={handleNavClick}
              className={({ isActive }) =>
                "mq-nav-link" + (isActive ? " mq-nav-link-active" : "")
              }
            >
              <span className="mq-nav-icon">
                <IconReviews />
              </span>
              <span>Reviews</span>
            </NavLink>

            <NavLink
              to="/demo-requests"
              onClick={handleNavClick}
              className={({ isActive }) =>
                "mq-nav-link" + (isActive ? " mq-nav-link-active" : "")
              }
            >
              <span className="mq-nav-icon">
                <IconInbox />
              </span>
              <span>Demo Requests</span>
            </NavLink>

            <NavLink
              to="/route-optimization"
              onClick={handleNavClick}
              className={({ isActive }) =>
                "mq-nav-link" + (isActive ? " mq-nav-link-active" : "")
              }
            >
              <span className="mq-nav-icon">
                <IconRouteOpt />
              </span>
              <span>Route Optimization</span>
            </NavLink>
          </nav>
        </div>

        {/* OTHER section */}
        <div className="mq-nav-section mq-nav-section-bottom">
          <div className="mq-nav-label">OTHER</div>
          <nav className="mq-nav">
            <NavLink
              to="/settings"
              onClick={handleNavClick}
              className={({ isActive }) =>
                "mq-nav-link" + (isActive ? " mq-nav-link-active" : "")
              }
            >
              <span className="mq-nav-icon">
                <IconSettings />
              </span>
              <span>Settings</span>
            </NavLink>
            <NavLink
              to="/help"
              onClick={handleNavClick}
              className={({ isActive }) =>
                "mq-nav-link" + (isActive ? " mq-nav-link-active" : "")
              }
            >
              <span className="mq-nav-icon">
                <IconHelp />
              </span>
              <span>Help &amp; Support</span>
            </NavLink>
          </nav>
        </div>
      </div>
    </aside>
  );
}
